import axios from "axios";

const getAllOrdersList = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/orders/order-list`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => console.log(error));
  });
};

export { getAllOrdersList };
